import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "../../../axios";

export const profileApi = createAsyncThunk(
  "user/profile",
  async (_, { rejectWithValue }) => {
    try {
      const response = await axios.get("/users/profile");
      return response.data;
    } catch (error) {
      console.error("Profile API error:", error);
      if (error.response && error.response.data) {
        return rejectWithValue(
          error.response.data.message || "Failed to fetch profile"
        );
      }
      return rejectWithValue("Failed to fetch profile");
    }
  }
);
